import * as React from "react";
function SvgDisc(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <circle cx={24} cy={24} r={24} />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgDisc);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
